(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dp-brands"] && !Shopify.designMode) return;
  try {
    
function initBrandDirectories(root=document){root.querySelectorAll('[data-dp-brand-directory]').forEach(directory=>{if(directory.dataset.ready)return;directory.dataset.ready='true';const search=directory.querySelector('[data-brand-search]');if(!search)return;const cards=[...directory.querySelectorAll('[data-brand-name]')],buttons=[...directory.querySelectorAll('[data-letter]')];let letter='';const update=()=>{const normalize=value=>value.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLocaleLowerCase();const term=normalize(search.value.trim());let count=0;cards.forEach(card=>{const name=card.dataset.brandName;const visible=normalize(name).includes(term)&&(!letter||(letter==='0-9'?/^[0-9]/.test(name):name.toLocaleUpperCase().startsWith(letter)));card.hidden=!visible;if(visible)count++});const status=directory.querySelector('[data-brand-count]');status.textContent=count+' '+(count===1?status.dataset.countSingular:status.dataset.countLabel);directory.querySelector('[data-brand-empty]').hidden=count>0};buttons.forEach(button=>{const initial=button.dataset.letter;button.disabled=!!initial&&!cards.some(card=>(initial==='0-9'?/^[0-9]/.test(card.dataset.brandName):card.dataset.brandName.toLocaleUpperCase().startsWith(initial)));button.addEventListener('click',()=>{letter=initial;buttons.forEach(b=>b.setAttribute('aria-pressed',String(b===button)));update()})});search.addEventListener('input',update)})}
initBrandDirectories();document.addEventListener('shopify:section:load',()=>initBrandDirectories());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dp-build-gallery"] && !Shopify.designMode) return;
  try {
    
function dpInitBuildGalleries(){document.querySelectorAll('[data-build-gallery]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const slides=Array.from(root.querySelectorAll('figure')),controls=root.querySelector('.dp-build-gallery__controls'),pause=root.querySelector('[data-gallery-pause]'),count=root.querySelector('[data-gallery-count]'),motion=matchMedia('(prefers-reduced-motion: reduce)');if(!slides.length)return;let current=0,stopped=motion.matches,hover=false,visible=false;const label=()=>{pause.textContent=stopped?pause.dataset.play:pause.dataset.pause;pause.setAttribute('aria-pressed',String(stopped))};const show=index=>{current=(index+slides.length)%slides.length;slides.forEach((slide,i)=>slide.hidden=i!==current);count.textContent=String(current+1).padStart(2,'0')+' / '+String(slides.length).padStart(2,'0')};show(0);if(slides.length<2)return;controls.hidden=false;root.querySelector('[data-gallery-prev]').addEventListener('click',()=>{stopped=true;label();show(current-1)});root.querySelector('[data-gallery-next]').addEventListener('click',()=>{stopped=true;label();show(current+1)});pause.addEventListener('click',()=>{stopped=!stopped;label()});root.addEventListener('mouseenter',()=>hover=true);root.addEventListener('mouseleave',()=>hover=false);motion.addEventListener('change',()=>{stopped=motion.matches;label()});const observer=new IntersectionObserver(entries=>visible=entries[0].isIntersecting);observer.observe(root);const timer=setInterval(()=>{if(!root.isConnected){clearInterval(timer);observer.disconnect();return}if(visible&&!stopped&&!hover&&!document.hidden&&!root.contains(document.activeElement))show(current+1)},5500);label()})}dpInitBuildGalleries();document.addEventListener('shopify:section:load',dpInitBuildGalleries);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dp-community"] && !Shopify.designMode) return;
  try {
    
class DpcEventSlideshow extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.slides = Array.from(this.querySelector('.dpc-gallery').children);
    this.index = 0;
    this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.paused = this.dataset.editor === 'true' || this.motion.matches;
    this.hovering = false;
    this.counter = this.querySelector('[data-counter]');
    this.toggle = this.querySelector('[data-toggle]');
    this.querySelector('[data-previous]').addEventListener('click', () => this.manual(-1), options);
    this.querySelector('[data-next]').addEventListener('click', () => this.manual(1), options);
    this.toggle.addEventListener('click', () => {
      this.paused = !this.paused;
      this.refresh();
    }, options);
    this.addEventListener('mouseenter', () => { this.hovering = true; this.schedule(); }, options);
    this.addEventListener('mouseleave', () => { this.hovering = false; this.schedule(); }, options);
    this.addEventListener('focusin', event => {
      if (event.target === this.toggle) { window.clearTimeout(this.timer); return; }
      this.paused = true;
      this.refresh();
    }, options);
    document.addEventListener('visibilitychange', () => this.schedule(), options);
    this.motion.addEventListener('change', () => {
      if (this.motion.matches) this.paused = true;
      this.refresh();
    }, options);
    this.addEventListener('shopify:block:select', event => {
      const index = this.slides.findIndex(slide => slide === event.target || slide.contains(event.target));
      if (index >= 0) {
        this.paused = true;
        this.show(index);
      }
    }, options);
    this.querySelector('.dpc-gallery-controls').hidden = this.slides.length < 2;
    this.setAttribute('data-ready', '');
    this.show(0);
  }
  manual(step) {
    this.paused = true;
    this.show(this.index + step);
  }
  show(index) {
    if (!this.slides.length) return;
    this.index = (index + this.slides.length) % this.slides.length;
    this.slides.forEach((slide, i) => {
      slide.hidden = i !== this.index;
      if (slide.hidden) slide.querySelectorAll('video').forEach(video => video.pause());
    });
    this.counter.textContent = (this.index + 1) + ' / ' + this.slides.length;
    this.refresh();
  }
  refresh() {
    this.toggle.textContent = this.paused ? this.dataset.play : this.dataset.pause;
    this.schedule();
  }
  schedule() {
    window.clearTimeout(this.timer);
    if (this.paused || this.hovering || document.hidden || this.slides.length < 2) return;
    if (this.slides[this.index]?.querySelector('video')) return;
    this.timer = window.setTimeout(() => this.show(this.index + 1), 5000);
  }
  disconnectedCallback() {
    window.clearTimeout(this.timer);
    this.controller?.abort();
    this.controller = null;
  }
}
if (!customElements.get('dpc-event-slideshow')) customElements.define('dpc-event-slideshow', DpcEventSlideshow);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dp-header"] && !Shopify.designMode) return;
  try {
    
function observeDeathproofHeader(){
  const header=document.querySelector('.dp-sticky-header');
  if(!header||header.dataset.heightObserved)return;
  header.dataset.heightObserved='true';
  const update=()=>document.documentElement.style.setProperty('--dp-sticky-header-height',header.getBoundingClientRect().height+'px');
  update();
  const observer=new ResizeObserver(update);
  observer.observe(header);
  const cleanup=event=>{if(event.target===header){observer.disconnect();document.removeEventListener('shopify:section:unload',cleanup)}};
  document.addEventListener('shopify:section:unload',cleanup);
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',observeDeathproofHeader);
else observeDeathproofHeader();
document.addEventListener('shopify:section:load',observeDeathproofHeader);

document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.dp-header__mobile[open]').forEach(menu=>{menu.open=false;menu.querySelector('summary').focus()})});
document.addEventListener('click',event=>{document.querySelectorAll('.dp-header__mobile[open]').forEach(menu=>{if(!menu.contains(event.target)||event.target.closest('a'))menu.open=false})});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dp-hero"] && !Shopify.designMode) return;
  try {
    
function initDeathproofHero(scope = document) {
  scope.querySelectorAll('[data-dp-hero]').forEach(root => {
    if (root.dataset.motionReady) return;
    root.dataset.motionReady = 'true';
    const controller = new AbortController();
    const options = { signal: controller.signal };
    const button = root.querySelector('[data-dp-motion-toggle]');
    const slides = Array.from(root.querySelectorAll('[data-dp-slide]'));
    const video = root.querySelector('video');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    let index = 0;
    let paused = reduced.matches;
    let timer;
    let pending = false;
    if (video) { root.dataset.hasVideo = 'true'; video.controls = false; }
    const stopped = () => paused || document.hidden || !root.isConnected;
    const schedule = () => {
      clearTimeout(timer);
      if (!stopped() && !video && slides.length > 1) timer = setTimeout(advance, 6000);
    };
    const advance = async () => {
      if (stopped() || pending) return;
      pending = true;
      const next = (index + 1) % slides.length;
      const img = slides[next].querySelector('img');
      try { if (img && img.decode) await img.decode(); } catch (_) {
        pending = false;
        schedule();
        return;
      }
      pending = false;
      if (stopped()) return;
      slides[index].classList.remove('is-active');
      slides[next].classList.add('is-active');
      index = next;
      schedule();
    };
    const update = () => {
      root.toggleAttribute('data-motion-paused', paused || document.hidden);
      button.textContent = paused ? button.dataset.play : button.dataset.pause;
      button.hidden = false;
      if (video) {
        if (stopped()) video.pause();
        else video.play().then(() => {
          if (stopped()) video.pause();
          else root.setAttribute('data-video-playing', '');
        }).catch(() => { paused = true; update(); });
      }
      schedule();
    };
    slides.forEach((slide, i) => slide.classList.toggle('is-active', i === 0));
    button.addEventListener('click', () => { paused = !paused; update(); }, options);
    reduced.addEventListener('change', () => { paused = reduced.matches; update(); }, options);
    document.addEventListener('visibilitychange', update, options);
    root.addEventListener('shopify:block:select', event => {
      const selected = slides.findIndex(slide => slide === event.target || slide.contains(event.target));
      if (selected < 0) return;
      paused = true;
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === selected));
      index = selected;
      update();
    }, options);
    document.addEventListener('shopify:section:unload', event => {
      if (!event.target.contains(root)) return;
      clearTimeout(timer);
      controller.abort();
    }, options);
    update();
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initDeathproofHero());
else initDeathproofHero();
document.addEventListener('shopify:section:load', event => initDeathproofHero(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dp-home-brands"] && !Shopify.designMode) return;
  try {
    
function dpInitBrandCarousels(){document.querySelectorAll('[data-brand-carousel]').forEach(root=>{
if(root.dataset.carouselReady)return;root.dataset.carouselReady='true';
const rail=root.querySelector('ul'),pause=root.querySelector('[data-brand-pause]'),motion=matchMedia('(prefers-reduced-motion: reduce)');
const originalCards=Array.from(rail.children);if(originalCards.length<2)return;
const priorityNames=['THRASHIN SUPPLY CO.','SADDLEMEN','S&S CYCLE'];
const priorityCards=priorityNames.map(name=>originalCards.find(card=>card.dataset.brand===name)).filter(Boolean);
const randomCards=originalCards.filter(card=>!priorityCards.includes(card));
for(let i=randomCards.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[randomCards[i],randomCards[j]]=[randomCards[j],randomCards[i]]}
const cards=[...priorityCards,...randomCards];rail.append(...cards);rail.scrollLeft=0;
const clones=cards.slice(0,6).map(card=>{const clone=card.cloneNode(true);clone.setAttribute('aria-hidden','true');clone.querySelectorAll('a').forEach(a=>a.tabIndex=-1);rail.append(clone);return clone});
let stopped=motion.matches,hover=false,visible=false,last=0,position=rail.scrollLeft,period=0,frame;
const measure=()=>{period=clones[0].getBoundingClientRect().left-cards[0].getBoundingClientRect().left};
const resize=new ResizeObserver(measure);resize.observe(rail);measure();
const update=()=>{pause.textContent=stopped?'Play':'Pause';pause.setAttribute('aria-pressed',String(stopped))};
const move=direction=>{stopped=true;update();const step=cards[0].getBoundingClientRect().width+parseFloat(getComputedStyle(rail).gap);let target=rail.scrollLeft+direction*step;if(target<0){rail.scrollLeft+=period;target+=period}if(target>=period)target-=period;rail.scrollTo({left:target,behavior:motion.matches?'instant':'smooth'})};
root.querySelector('[data-brand-prev]').addEventListener('click',()=>move(-1));root.querySelector('[data-brand-next]').addEventListener('click',()=>move(1));
pause.addEventListener('click',()=>{stopped=!stopped;position=rail.scrollLeft;update()});
rail.addEventListener('mouseenter',()=>hover=true);rail.addEventListener('mouseleave',()=>hover=false);
rail.addEventListener('pointerdown',()=>{stopped=true;update()});rail.addEventListener('wheel',()=>{stopped=true;update()},{passive:true});
motion.addEventListener('change',()=>{stopped=motion.matches;update()});
const observer=new IntersectionObserver(entries=>visible=entries[0].isIntersecting);observer.observe(root);
const tick=now=>{if(!root.isConnected){resize.disconnect();observer.disconnect();return}const elapsed=last?Math.min(now-last,50):0;last=now;if(!stopped&&!hover&&visible&&!document.hidden&&!rail.contains(document.activeElement)&&period>0){position=(position+elapsed*.03)%period;rail.scrollLeft=position}else position=rail.scrollLeft;frame=requestAnimationFrame(tick)};frame=requestAnimationFrame(tick);update()
})}dpInitBrandCarousels();document.addEventListener('shopify:section:load',dpInitBrandCarousels);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dp-home-finder"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',event=>{
 const link=event.target.closest('a[href]');
 if(!link)return;
 const destination=new URL(link.href,location.href);
 if(destination.pathname!==location.pathname||destination.hash!=='#dp-bike-finder')return;
 const finder=document.querySelector('.dp-home-finder [data-dp-bike-finder]');
 if(finder){finder.open=true;finder.querySelector('summary').focus({preventScroll:true});}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dp-wheelie-game"]) return;
  try {
    
window.addEventListener('message',event=>{
  if(event.origin!=='https://deathproof-wheelie-run.deathproof-cycles.chatgpt.site'||event.data?.type!=='dp-wheelie-height')return;
  if(!Number.isFinite(event.data.height)||event.data.height<300||event.data.height>5000)return;
  document.querySelectorAll('.dp-wheelie-page__frame').forEach(frame=>{if(event.source===frame.contentWindow)frame.style.height=Math.ceil(event.data.height)+'px';});
});

  } catch(e) { console.error(e); }
})();
})();
